import { Skeleton } from "@/components/ui/skeleton";

export const CardSkeleton = () => (
  <div><Skeleton className="aspect-[16/10] rounded-xl" /><Skeleton className="mt-3 h-3 w-24" /><Skeleton className="mt-2 h-5 w-full" /><Skeleton className="mt-1.5 h-5 w-2/3" /></div>
);

export const GridSkeleton = ({ n = 6 }) => (
  <div className="grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">{Array.from({ length: n }).map((_, i) => <CardSkeleton key={i} />)}</div>
);

export const HeroSkeleton = () => (
  <div className="grid gap-4 lg:grid-cols-12">
    <Skeleton className="h-[420px] rounded-2xl lg:col-span-8 lg:h-[540px]" />
    <div className="grid gap-4 lg:col-span-4">{[0, 1, 2].map((i) => <Skeleton key={i} className="h-[150px] rounded-2xl" />)}</div>
  </div>
);
